import { DirectiveBinding, Directive } from 'vue';
const useIntersectionObserver = (el: HTMLElement, binding: DirectiveBinding) => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const opt = binding.value;
      if (entry.isIntersecting && opt.inView) {
        opt.inView(el);
      }
      if (!entry.isIntersecting && opt.outView) {
        opt.outView(el);
      }
      if (binding.once) {
        observer.unobserve(el);
      }
    });
  });
  observer.observe(el);
  if (!binding.once) {
    el.__observerInstance = observer;
  }
};

export const viewPort: Directive = {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    useIntersectionObserver(el, binding);
  },
  unmounted(el: any) {
    el.__observerInstance?.unobserve(el);
  }
};

export default {
  install(app: any) {
    app.directive('view-port', viewPort);
  }
};
